module.exports = __webpack_public_path__ + "media/images/subject_img/PARAMEDIC SCIENCE-687f4984536db97108e1154481c03861.jpg";